import * as React from 'react';
import { useInView } from 'react-intersection-observer';

interface LazyGifProps {
  alt: string;
  className?: string;
  gifSrc: string;
  placeholderSrc?: string;
}

const LazyGif: React.FC<LazyGifProps> = (props) => {
  const { alt, className = '', gifSrc, placeholderSrc = '' } = props;

  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  const imgSrc = inView ? gifSrc : placeholderSrc;

  return <img alt={alt} className={className} ref={ref} src={imgSrc} />;
};

export { LazyGif };
